"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M11.5024 9.045c0-.5524.4478-1 1-1 .5523 0 1 .4476 1 1 0 .5522-.4477.9999-1 .9999-.5522 0-1-.4477-1-1zm-3 0c0-.5524.4478-1 1-1 .5523 0 1 .4476 1 1 0 .5522-.4477.9999-1 .9999-.5522 0-1-.4477-1-1zm1.5 2.955c0-.5523.4478-1 1-1 .5523 0 1 .4477 1 1s-.4477 1-1 1c-.5522 0-1-.4477-1-1z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8501 4.002h14.306l-.2857 2h.133c2.2092 0 4 1.7908 4 4 0 2.2091-1.7908 4-4 4h-1.2759l-.8571 6H6.1358l-2.2857-16zm13.1632 8 .5714-4h.4187c1.1046 0 2 .8954 2 2 0 1.1045-.8954 2-2 2h-.9901zm-10.8572-6 1.7143 12h6.2654l1.7143-12h-9.694z"
  })];
};

exports.default = _default;